export default {
  experimentId: '15',
  serverUrl: 'https://magpie-cogsciprag.fly.dev',
  socketUrl: 'wss://magpie-cogsciprag.fly.dev/socket',
  contactEmail: 'alexwarstadt@gmail.com',
  completionUrl: 'https://app.prolific.com/submissions/complete?cc=C5LQGSYV',
  // Either 'debug', 'directLink' or 'prolific'
  mode: 'prolific'
};
